import { lazyRouteComponent, useParams } from '@tanstack/react-router'
import { Suspense, useEffect } from 'react'
import { usePictureInPictureStore } from './pictureInPictureStore'

const PictureInPictureHost = lazyRouteComponent(() => import('./PictureInPictureHost'), 'PictureInPictureHost')

/** The first open has to render the host inside the click that pops it out, so it cannot wait on a chunk. */
export const preloadPictureInPictureHost = () => PictureInPictureHost.preload?.()

/** The panel in picture in picture, over every page of the project it was opened in. */
export function PictureInPictureSlot() {
	const { tenantId } = useParams({ strict: false })
	return <ProjectPictureInPicture key={tenantId} tenantId={tenantId} />
}

function ProjectPictureInPicture({ tenantId }: { tenantId: string | undefined }) {
	const entry = usePictureInPictureStore(state => state.entry)

	// Leaving the project, for another one or by signing out, unmounts this and closes the panel. Its requests
	// carry the tenant of the URL, so it cannot outlive its project.
	useEffect(() => () => usePictureInPictureStore.getState().close(), [])

	// The render before the previous project's slot unmounts still holds that project's panel.
	if (!entry || entry.tenantId !== tenantId) {
		return null
	}
	return (
		<Suspense fallback={null}>
			<PictureInPictureHost key={`${entry.dashboardId}:${entry.deviceId}:${entry.panelId}`} entry={entry} />
		</Suspense>
	)
}
